import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CTASection() {
  return (
    <section className="relative py-24 lg:py-32 bg-[#0a0a0a] overflow-hidden">
      <div
        className="absolute inset-0 opacity-20 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 70% 50% at 50% 50%, rgba(184,115,51,0.25), transparent 65%)"
        }}
      />
      <div className="relative max-w-[1200px] mx-auto px-6 lg:px-10 text-center">
        <div className="inline-flex items-center gap-3 mb-6">
          <span className="divider-line" />
          <span className="text-[11px] tracking-[0.4em] text-[#B87333]">HAZIR MISINIZ?</span>
          <span className="divider-line" />
        </div>
        <h2 className="font-serif-display text-[#f5ede1] text-4xl md:text-5xl lg:text-6xl leading-tight font-light">
          Yatırım yolculuğunuzda bir sonraki adımınız için birlikte çalışalım.
        </h2>
        <p className="mt-6 text-[#a89a85] max-w-2xl mx-auto">
          AR Danışmanlık ekibiyle ücretsiz ön görüşme talep edin; işletmenize özel teşvik haritanızı çıkaralım.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/iletisim"
            className="group inline-flex items-center gap-3 px-10 py-4 bg-[#B87333] text-[#0a0a0a] text-[11px] tracking-[0.3em] font-semibold hover:bg-[#D4A574] transition-colors duration-300"
          >
            ÜCRETSİZ GÖRÜŞME <ArrowRight className="w-4 h-4" />
          </Link>
          <Link
            to="/hizmetlerimiz"
            className="inline-flex items-center gap-3 px-10 py-4 border border-[#B87333]/40 text-[#f5ede1] text-[11px] tracking-[0.3em] font-semibold hover:border-[#B87333] hover:text-[#B87333] transition-colors duration-300"
          >
            HİZMETLERİMİZ
          </Link>
        </div>
      </div>
    </section>
  );
}
